import * as PIXI from "pixi.js";
import { MouseTypeContainer } from "./InteractiveContainer";
import { MouseClickType } from "../Settings/Enums";
import { UIPositioning } from "../Settings/UITheme";
export class VerticalScrollView extends MouseTypeContainer {
    constructor(width, height) {
        super();
        this.scrollingEnabled = true;
        this._sidebarPosition = UIPositioning.sequencerSidebarWidth;
        this._verticalScrollPosition = 0;
        this._interactivityRect = new PIXI.Graphics();
        this.addChild(this._interactivityRect);
        this.endX = width;
        this.endY = height;
        this.resizeInteractiveArea(width, height);
        this.on("added", this.addedHandler);
        this.on("removed", this.removedHandler);
    }
    resize(width, height) {
        this.endX = width;
        this.endY = height;
        this.resizeInteractiveArea(width, height);
        this.timeline.resize(width, height);
    }
    get verticalScrollPosition() {
        return this._verticalScrollPosition;
    }
    set verticalScrollPosition(value) {
        let oldVSP = this._verticalScrollPosition;
        this._verticalScrollPosition = Math.min(0, Math.max(-this.contentHeight + this.endY - 2, value));
        if (oldVSP != this._verticalScrollPosition) {
            this.updateVerticalScroll(this._verticalScrollPosition);
        }
    }
    resizeInteractiveArea(width, height) {
        this._interactivityRect.clear();
        this._interactivityRect.beginFill(0x000000, 1.0);
        this._interactivityRect.drawRect(0, 0, width, height);
        this._interactivityRect.endFill();
        this._interactivityRect.alpha = 0.0;
    }
    pointerDownHandler(event) {
        super.pointerDownHandler(event);
        if (this._mouseClickType == MouseClickType.None) {
            return;
        }
        this._startPointerPosition = event.data.getLocalPosition(this);
        this._startVerticalScrollPosition = this._verticalScrollPosition;
    }
    pointerMoveHandler(event) {
        if (this._mouseClickType == MouseClickType.LeftClick && this.scrollingEnabled) {
            this.verticalScrollPosition = event.data.getLocalPosition(this).y - this._startPointerPosition.y + this._startVerticalScrollPosition;
        }
    }
    pointerUpHandler(event) {
        super.pointerUpHandler(event);
        this._startPointerPosition = undefined;
        this._startVerticalScrollPosition = undefined;
    }
    pointerUpDragHandler(event) {
        if (this._mouseClickType == MouseClickType.LeftClick && this.scrollingEnabled) {
            this.verticalScrollPosition = event.data.getLocalPosition(this).y - this._startPointerPosition.y + this._startVerticalScrollPosition;
        }
    }
    mouseWheelHandler(event, canvasX, canvasY) {
        this.timeline.mouseWheelHandler(event, canvasX, canvasY);
    }
    addedHandler() {
        this.timeline.addedHandler();
    }
    removedHandler() {
        this.timeline.removedHandler();
    }
    destroy() {
        super.destroy({ children: true });
    }
}
//# sourceMappingURL=VerticalScrollView.js.map